import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-JAXCH6PI.mjs";
import "./chunk-O6L2WK4J.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
